import { render, staticRenderFns } from "./purchasing-price-list.vue?vue&type=template&id=71776b3e&"
import script from "./purchasing-price-list.vue?vue&type=script&lang=js&"
export * from "./purchasing-price-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports